import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

class ConvertPDF extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );

		this.init();
	}
	loadAllImages(element) {
		return  new Promise((resolve) => {
			const images = element.getElementsByTagName('img');
			let loaded = 0;
			if (images.length === 0) resolve();

			for (let img of images) {
				if (img.complete) {
					loaded++;
					if (loaded === images.length) resolve();
				} else {
					img.onload = img.onerror = () => {
						loaded++;
						if (loaded === images.length) resolve();
					};
				}
			}
		});
	}

	async convertSVGImagesToInline(element) {
		const images = element.querySelectorAll("img.svg-img");
		for (let img of images) {
			const src = img.src;

			// Fetch the raw SVG data
			try {
				const response = await fetch(src);
				const svgText = await response.text();

				// Convert the SVG text to a DOM element
				const parser = new DOMParser();
				const svgDoc = parser.parseFromString(svgText, "image/svg+xml").documentElement;

				// Copy styles and replace the <img> with inline <svg>
				svgDoc.setAttribute("width", img.width);
				svgDoc.setAttribute("height", img.height);
				img.replaceWith(svgDoc);
			} catch (error) {
				console.error("Failed to load SVG:", error);
			}
		}
	}
	init(){
		const THIS = this
		this.selector.addEventListener('click',async function(){
			const pdf = new jsPDF('p', 'mm', 'a4');

			const pdfWidth = pdf.internal.pageSize.getWidth();
			const pdfHeight = pdf.internal.pageSize.getHeight();
			pdf.setFillColor("fff");
			pdf.rect(0, 0, pdfWidth, pdfHeight, 'F');
			let getPdf = document.getElementById("data-convert-pdf")
			let footerPdf:HTMLElement = getPdf.querySelector('.raise-bfg-footer-note')
			getPdf.querySelectorAll("*").forEach(el => {
				const before = window.getComputedStyle(el, "::before").content;
				const after = window.getComputedStyle(el, "::after").content;
				if (before !== "none") el.style.setProperty("content", "none", "important");
				if (after !== "none") el.style.setProperty("content", "none", "important");
			});
			// Convert external SVGs to inline SVGs before capturing
			await THIS.convertSVGImagesToInline(getPdf)
			let getSections = Array.from(getPdf.querySelectorAll("&>*"))
			if(getSections.length > 0){
				let pageNum = 0;
				let y = 0
				const imgWidth = 210; // A4 width in mm
				const pageHeight = 297; // A4 height in mm
				for (let i = 0; i < getSections.length; i++) {
					const section = getSections[i] as HTMLElement;
					await THIS.loadAllImages(section);

					if (section.classList.contains('page-break-before') && i !== 0) {
						pdf.addPage();
						if(i > 0 && i < getSections.length - 1){
							pdf.setFillColor("F9F4F2");
						}else{
							pdf.setFillColor("fff");
						}
						pdf.rect(0, 0, pdfWidth, pdfHeight, 'F');
						pageNum++;
					}
					let optionCanvas = {
						scale: 1.5,
						useCORS: true,
						allowTaint: true,
						logging: false,
						padding: 0,
						windowWidth: 1992,
					}

					const canvas = await html2canvas(section, optionCanvas);


					const elements = section.querySelectorAll("p, a");
					const pageHeightPx = (canvas.width * pageHeight) / imgWidth;
					let renderedHeight = 0;

					while (renderedHeight < canvas.height) {
						const sliceCanvas = document.createElement('canvas');
						const sliceHeight = Math.min(pageHeightPx, canvas.height - renderedHeight);
						sliceCanvas.width = canvas.width;
						sliceCanvas.height = sliceHeight;

						const ctx = sliceCanvas.getContext('2d');
						ctx.drawImage(
							canvas,
							0, renderedHeight,
							canvas.width, sliceHeight,
							0, 0,
							canvas.width, sliceHeight
						);
						elements.forEach((el: any) => {
							if (el.tagName === "P") {
								y += 6;
							} else if (el.tagName === "A") {
								pdf.saveGraphicsState();
								pdf.setGState(new pdf.GState({opacity: 0}));
								pdf.setFontSize(12);
								// pdf.setTextColor(255, 255, 255, 0); // Fully transparent text
								y += 6;
								pdf.textWithLink(el.innerText, 120, y, { url: el.href });
								pdf.restoreGraphicsState();
							}
						});
						const imgData = sliceCanvas.toDataURL('image/jpeg');
						const displayHeight = (sliceHeight * imgWidth) / canvas.width;

						pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, displayHeight);
						renderedHeight += pageHeightPx;

						if (renderedHeight < canvas.height) {
							pdf.addPage();
							pageNum++;
							if(i > 0 && i < getSections.length - 1){
								pdf.setFillColor("F9F4F2");
							}else{
								pdf.setFillColor("fff");
							}
							pdf.rect(0, 0, pdfWidth, pdfHeight, 'F');
						}
					}
				}

				const footerClone = footerPdf.cloneNode(true);
				footerClone.style.display = "block";
				footerClone.style.position = "absolute";
				footerClone.style.left = "0";
				footerClone.style.top = "0";

				document.body.appendChild(footerClone);

// Step 3: Render the stretched version
				const footerCanvas = await html2canvas(footerClone, {
					scale: 1.5,
					useCORS: true,
				});

				document.body.removeChild(footerClone); // Clean up after rendering

// Step 4: Use it in PDF
				const footerImg = footerCanvas.toDataURL("image/jpeg");
				const footerProps = pdf.getImageProperties(footerImg);
				const footerHeightMM = (footerProps.height * imgWidth) / footerProps.width;
				const footerY = pageHeight - footerHeightMM;
				const totalPages = pdf.getNumberOfPages();
				pdf.setPage(totalPages);
				pdf.addImage(footerImg, "jpeg", 0, footerY, imgWidth, footerHeightMM);
				pdf.save("impact-report.pdf");
			}
		})
	}
}

export default ConvertPDF;
